import React from 'react'
import styled from 'styled-components'

const ImageWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.common.border};
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  border: ${({ theme }) => `1.5px solid ${theme.colors.common.border}`};
`

const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`

const StyledDoctorInitials = styled.p`
  width: 100%;
  font-size: 16px;
  line-height: 40px;
  font-weight: 500;
  letter-spacing: 0.3px;
  text-align: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.common.white};
`

const getInitials = (userName: string): string | undefined =>
  userName
    .match(/(^\S\S?|\s\S)?/g)
    ?.map((v) => v.trim())
    ?.join('')
    ?.match(/(^\S|\S$)?/g)
    ?.join('')

type DoctorImageProps = React.ImgHTMLAttributes<HTMLImageElement>

const DoctorImage: React.FC<DoctorImageProps> = (props) => {
  return (
    <ImageWrapper>
      <StyledImg alt="doctor" {...props} />
    </ImageWrapper>
  )
}

const DoctorInitials: React.FC<{ name: string }> = ({ name }) => {
  return (
    <ImageWrapper>
      <StyledDoctorInitials>{getInitials(name)}</StyledDoctorInitials>
    </ImageWrapper>
  )
}

export { DoctorImage, DoctorInitials }
